import type { PublicSlotKey } from '@/apilib';
import type { SectionsApi } from './api';

export const SectionsApiKey: PublicSlotKey<SectionsApi> = {
  name: 'SectionsApi',
  public: true,
};
